"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M0 12c0 4.458 5.382 8.076 12 8.076S24 16.45 24 12c0-4.449-5.382-8.076-12-8.076S0 7.542 0 12Zm1.847 0c0-3.378 4.615-6.23 10.153-6.23S22.153 8.622 22.153 12c0 3.378-4.615 6.23-10.153 6.23S1.847 15.378 1.847 12Zm7.476 4.034a4.818 4.818 0 1 0 5.354-8.013 4.818 4.818 0 0 0-5.354 8.013Zm1.026-6.478a2.972 2.972 0 0 1 1.651-.5v-.028a2.972 2.972 0 0 1 2.972 3 2.972 2.972 0 1 1-4.623-2.472Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};